import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import { CellRenderers, columnRenderArrayData } from "utils/tableUtils";
import BitSightCredentialsForm from "./BitSightCredentialsForm";
import BitSightMappingForm from "./BitSightMappingForm";

export default function BitSightConfigListing(props) {
  const columns = useMemo(
    () => [
      {
        title: "Company",
        dataIndex: "companyName",
        width: 200,
      },
      {
        title: "Subsidiary",
        dataIndex: "subsidiaryNames",
        //subsidiaryName usually contains comma in their name, checking if the subsidiary is single or multiple through id
        render: (subsidiaryName, record) =>
          record.subsidiaryIds.includes(",")
            ? columnRenderArrayData(subsidiaryName)
            : subsidiaryName,
        width: 200,
      },
      {
        title: "Tags",
        dataIndex: "tags",
        width: 200,
        render: CellRenderers.VALUE_OR_NA
      },
    ],
    []
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      extraColumns={columns}
      MappingForm={BitSightMappingForm}
      CredentialsForm={BitSightCredentialsForm}
    />
  );
}
